import { Component, OnInit, Inject, NgZone } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ApiService } from '../services/api.service';
import { ServiceConfigService } from '@app/services/service-config.service';
import Vs from '@app/services/validators/validators.service';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalService } from '@app/services/modal/modal.service';
import { RecaptchaLoaderService } from 'ng-recaptcha-2';
import { RecaptchaLanguageLoaderService } from '@app/services/recaptcha-language-loader.service';
import { HttpHeaders } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { TokenService } from '@app/services/token/token.service';

@Component({
    selector: 'nh-forgotuser-name',
    templateUrl: './forgotuser-name.component.html',
    styleUrls: ['./forgotuser-name.component.scss'],
    standalone: false
})
export class ForgotuserNameComponent implements OnInit {
  isRecaptchaEnabled:boolean;
  forgotUsername = new FormGroup({
    email: new FormControl('', [Vs.email, Vs.required]),
    recaptchaReactive: new FormControl(null, Vs.required)
  })
  isForgotUsernameReview: boolean = false;
  siteKey: string;
  currentLang;
  loaderReady = false;
  sampleUsernamePlaceholder: string = 'name@example.com';

  constructor(
    @Inject(RecaptchaLoaderService)private loader: RecaptchaLanguageLoaderService,
    private zone: NgZone,
    private apiService: ApiService,
    public translateService: TranslateService,
    private serverConfig: ServiceConfigService,
    private router: Router,
    private modal: ModalService,
    private titleService: Title,
    private token: TokenService,
    private activatedRoute: ActivatedRoute,
    ) {
      this.titleService.setTitle('Forgot Username');
    this.siteKey = this.serverConfig.getServerConfig().SITE_KEY;
    this.isRecaptchaEnabled = this.serverConfig.getServerConfig().isRecaptchaEnabled;
    translateService.onDefaultLangChange.subscribe((res) => {
      this.switchLanguage(res.lang)
      res.lang === 'sp' ? this.changeRecaptchaLanguage('es') : this.changeRecaptchaLanguage('en')
    });
  }

  ngOnInit(): void {
    this.currentLang = this.translateService.defaultLang === 'sp' ? 'ES' : 'EN';
    this.updatePlaceholder(this.translateService.defaultLang);
    if (!this.isRecaptchaEnabled) {
      this.forgotUsername.removeControl('recaptchaReactive');
    }
    setTimeout(() => {
      const lang = this.translateService.getDefaultLang();
      lang === 'sp' ? this.changeRecaptchaLanguage('es') : this.changeRecaptchaLanguage('en')
    }, 1000);
    this.loader.ready.subscribe(v => {
      setTimeout(() => this.zone.run(() => this.loaderReady = !!v), 0);
    });
  }

  switchLanguage(lang) {
    if (lang === 'sp') {
      this.currentLang = 'ES'
    } else {
      this.currentLang = 'EN'
    }
    this.updatePlaceholder(lang);
  };

  updatePlaceholder(lang: string) {
    // Check for global language
    let selectedLang = sessionStorage.getItem('globalTranslatedLan');
    if (selectedLang === 'es') {
      selectedLang = 'sp';
    }
    const isGlobalLanguage = selectedLang && selectedLang !== 'en' && selectedLang !== 'sp';
    
    // For global languages or English, use English translation
    if (isGlobalLanguage || lang !== 'sp') {
      this.sampleUsernamePlaceholder = this.translateService.translations['en']?.['SAMPLE_USERNAME'] || 'name@example.com';
    } else {
      this.sampleUsernamePlaceholder = this.translateService.instant('SAMPLE_USERNAME');
    }
  }

  checkUserName(): void {
    const forgotUsernameJson = {
      email: this.forgotUsername['controls']['email'].value,
      language: this.currentLang,
    }
    this.apiService.post('publ/users/forgotUsername', forgotUsernameJson, { headers: new HttpHeaders({ 'pageId': 'TCFGU', 'sessionId': this.token.getSessionId() }) }).subscribe(() => {
      this.isForgotUsernameReview = true;
    });
  }

  resolved(captchaResponse: string) {
    const recaptachRequest = {
      'recaptchaResponseToken': captchaResponse,
      'chkRecaptcha': "YES"
    }
    this.apiService.post('publ/users/validateRecaptcha', recaptachRequest, { headers: new HttpHeaders({ 'pageId': 'TCFGU', 'sessionId': this.token.getSessionId() }) }).subscribe(() => {

    })
  }

  changeRecaptchaLanguage(lang) {
    this.loader.updateLanguage(lang);
  }

  onPrevious() {
    const currentQueryParams = this.activatedRoute.snapshot.queryParams;
    if(this.forgotUsername.pristine) {
      if(currentQueryParams?.utm_id && currentQueryParams?.utm_id === 'linkCaseCampaign') {
        this.router.navigate(['/signin'],{ queryParams: currentQueryParams });
      } else {
      this.router.navigateByUrl("/signin");
      }
      return;
    }
    this.modal.confirmDeactivate().subscribe(resp => {
      if (resp) {
        if(currentQueryParams?.utm_id && currentQueryParams?.utm_id === 'linkCaseCampaign') {
        this.router.navigate(['/signin'],{ queryParams: currentQueryParams });
      } else {
      this.router.navigateByUrl("/signin");
      }
      }
    });
  }

}
